import { Box } from '@mui/material'

// Tiled fractal-noise grain (tiny inline SVG, no network cost).
const grain =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='140' height='140'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"

/**
 * Cinematic atmosphere layer: a fixed film-grain texture + edge vignette over the
 * whole viewport. Pure CSS, pointer-events none, sits under the header/chrome.
 */
export function GrainOverlay() {
  return (
    <>
      <Box
        aria-hidden
        sx={{
          position: 'fixed',
          inset: 0,
          zIndex: 40,
          pointerEvents: 'none',
          backgroundImage: grain,
          backgroundSize: '140px 140px',
          opacity: 0.05,
          mixBlendMode: 'overlay',
        }}
      />
      <Box
        aria-hidden
        sx={{
          position: 'fixed',
          inset: 0,
          zIndex: 39,
          pointerEvents: 'none',
          background: 'radial-gradient(120% 90% at 50% 40%, transparent 55%, rgba(0,0,0,0.38) 100%)',
        }}
      />
    </>
  )
}
